export default __webpack_public_path__ + "img/Poppins-ExtraBold_31eaa61.ttf";